import { RootState } from "@/modules/common";

export const selectCouponsDiscount = (state: RootState) =>
  state.basket.basket.couponDiscount;
